module.exports = __webpack_public_path__ + "static/media/onde-comprar-shop-online.da03408a.svg";